export type ResponseProductWithoutBackendModification = {
  id: string;
  name: string;
  _match_rate: number;
  description_long: string;
  extended_description: string;
  itemcolour_ref: string;
  itemdescription: string;
  magento_id_product: string;
  variant_material: string;
  _thumburl: string;
  heading: string;
  stock_status_product_seq_allsize_au: number;
  stock_status_product_seq_au: number;
  imageUrl: string;
  url: string;
  fh_name: string;
  fh_slogan: string;

  base_colour_hex: {
    [key: string]: string;
  };
  label: string;
  colour_base_family: {
    [key: string]: string;
  };
  colour_base: {
    [key: string]: string;
  };
  filter_colour: {
    [key: string]: string;
  };
  feature: {
    [key: string]: string;
  };
  stock_avail_au: {
    [key: string]: string;
  };
  packagingLabel: string | null | undefined;
  priceLabel: string;
  price: number | string | null | undefined;
  rrp?: number | string | null | undefined;
  price_lowest: number | string | null | undefined;
  special_price: number | string | null | undefined;
  rewards_price: number | string | null | undefined;
  price_status_au: {
    m?: "M" | string;
    o?: "O" | string;
  };
  stockStatus: string | null | undefined;
  promoNotes: string | null | undefined;
};

export interface ResponseProductDinkus {
  dinkus_top_left?: string;
  dinkus_top_right?: string;
  dinkus_bottom_left?: string;
  dinkus_bottom_right?: string;
}

export type ResponseProductBackendModifications = {
  bbnt_product_ids?: string[];
  bbnt_gallery_images?: {
    [key: string]: string[];
  };
  bbnt_color_info?: {
    id: string;
    label: string | undefined | null;
    sort_order: string;
    products: string[];
    productSkus: string[];
  }[];
  bbnt_color_swatch?: {
    [key: string]: {
      type: "1" | "2" | "3";
      value: string;
    };
  };
  bbnt_product_urls?: {
    [key: string]: string;
  };
  bbnt_product_titles?: {
    [key: string]: string;
  };
  bbnt_product_dinkus?: {
    [key: string]: ResponseProductDinkus;
  };
};

export type ResponseProduct = ResponseProductWithoutBackendModification &
  ResponseProductBackendModifications;

export interface ResponseFacetValue {
  id: string;
  count: string;
  name: string;
}

export interface ResponseFacet {
  id: string;
  title: string;
  type: "cat" | "set" | "float" | "list" | string;
  multi: boolean;
  default_state: "Expanded" | "Collapsed";
  values: ResponseFacetValue[];
}

export enum ResponseFacetKey {
  stock_avail_au = "stock_avail_au",
  description_short = "description_short",
  colour_base_family = "colour_base_family",
  price_lowest_au = "price_lowest_au",
  rewards_pricing_au = "rewards_pricing_au",
  material = "material",
  thread_count = "thread_count",
}

export type FacetItemResponseKeyValues = keyof typeof ResponseFacetKey;

export type ResponseFacetsCollection = Record<
  ResponseFacetKey | string,
  ResponseFacet
>;

/**
 * O – Original RRP
 * rrp, regular_price, current_price all match
 *
 * SO – Special On Original RRP
 * rrp and regular_price match, regular_price > current_price
 *
 * M – Markdown Price
 * rrp > regular_price, regular_price and current_price match
 *
 * SM – Special Price On Markdown
 * rrp > regular_price, regular_price > current_price
 *
 * X - Error
 * None of the above current_price greater than either regurlar_price or rrp.
 */
export type PriceStatusType = "O" | "SO" | "M" | "SM" | "X";

export interface ResponseThemeProductWithoutBackendModification {
  id: string;
  price_status_au?: {
    [key: string]: PriceStatusType;
  };
  price_status_nz?: {
    [key: string]: PriceStatusType;
  };
  base_colour_hex: {
    [key: string]: string;
  };
  label: {
    [key: string]: string;
  };
  colour_base_family: {
    [key: string]: string;
  };
  colour_base: {
    [key: string]: string;
  };
  filter_colour: {
    [key: string]: string;
  };
  description_long: string;
  extended_description: string;
  heading: {
    [key: string]: string;
  };
  itemcolour_ref: string;
  itemdescription: string;
  magento_id_product: string;
  variant_material: string;
  name: {
    [key: string]: string;
  };
  page_url: string;
  url_prefix: string;
  _imageurl: string;
  _thumburl: string;
  price_label: {
    [key: string]: string;
  };
  packaging_label: string;
  price: number;
  rrp: number;
  price_lowest: number;
}

export type ResponseThemeProduct =
  ResponseThemeProductWithoutBackendModification &
    ResponseProductBackendModifications;

export type ResponseTheme = {
  title?: string;
  slogan?: string;
  name: String;
  static_content: any[];
  items: ResponseThemeProduct[] | any[];
};

export type ResponseThemeCollection = {
  [key: string]: ResponseTheme;
};

export interface RequestProductsSearch_Options {
  [key: string]: string | string[];

  // cat_id?: string | undefined;
}

export type RequestProductsSearch = {
  search: string;
  max: number;
  offset: number;
  sort: string;
  channel: string;
  backend: string;

  options: RequestProductsSearch_Options;
};

export interface ResponseProductsSearch {
  cursor: number;
  cursor_page_size: number;

  breadcrumbs: {
    id: string;
    name: string;
    type: string;
    url: string;
  }[];
  facets: ResponseFacetsCollection;
  params: {
    channel?: any;
    fh_location: string;
    fh_view: string;
    fh_view_size: number;
    state: string;
  };
  products: ResponseProduct[];
  redirect?: {
    redirect_url?: string;
  } | [];
  response_id: string;
  results: number;
  results_total: number;
  search?: {
    method: "OR" | string;
    term: string;
    replacements: {
      "estimated-results": number;
      replacement: string;
    }[];
  };
  sortable: {
    extended_description: string;
    heading: string;
    itemcolour_ref: string;
    itemdescription: string;
    label: string;
    magento_id_product: string;
    name: string;
    packaging_label: string;
    price_au: string;
    price_label: string;
    price_lowest_au: string;
    price_status_au: string;
    rewards_pricing_au: string;
    rewards_pricing_nz: string;
    rrp_au: string;
    stock_status_au: string;
    stock_status_product_seq_allsize_au: string;
    stock_status_product_seq_au: string;
    url_prefix: string;
  };
  themes: ResponseThemeCollection;
}

interface ReactPlpInitialStateProduct {
  id: string;
  name: string;
  _imageurl: string;
  description: string;
  sku: string;
  second_id: string;
  url_key: string;
  url: string;
  price: string;
  special_price: string | boolean;
  categories: {
    key: string;
    value: string;
  }[];
  brand: {
    key: string;
    value: string;
  }[];
  colour_primary: {
    key: string;
    value: string;
  }[];
  gender: {
    key: string;
    value: string;
  }[];
  material: any[];
  occasion: any[];
  site_variant: any[];
  colour: any[];
}
